import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { User, AuthService, AuthType, TranslateService, TohumUiModule } from '@anadolu-commons/tohum-ui';
import { HttpHeaders, HttpXsrfTokenExtractor, HttpClient } from '@angular/common/http';
import { FooterComponent } from "../shared/footer/footer.component";

@Component({
  selector: 'app-giris',
  standalone: true,
  imports: [TohumUiModule],
  templateUrl: './giris.component.html',
  styleUrls: ['./giris.component.scss']
})
export class GirisComponent implements OnInit {


  user: User;
  authenticated: boolean;
  authTypes: AuthType[];
  currentLang: string;

  constructor(private authService: AuthService, private router: Router,
    @Inject(DOCUMENT) private document: any, private translateService: TranslateService,
    private http: HttpClient, private tokenExtractor: HttpXsrfTokenExtractor) {
  }

  ngOnInit(): void {

    this.user = this.authService.getUser();
    this.authenticated = this.authService.isAuthenticated();
    this.currentLang = this.translateService.getLang();

    this.authTypes = [];
    for (const type in this.authService.authTypes) {
      if (this.authService.authTypes.hasOwnProperty(type)) {
        this.authTypes.push(type as AuthType);
      }
    }
  }

  loginForeign() {
    const token = this.tokenExtractor.getToken() as string;
    let headers = new HttpHeaders();
    if (token !== null) {
      headers = headers.append('X-XSRF-TOKEN', token);
    }
    this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
      this.document.location.href = result.data.redirectUrl;
    });
  }

  loginAnadolu() {
    const token = this.tokenExtractor.getToken() as string;
    let headers = new HttpHeaders();
    if (token !== null) {
      headers = headers.append('X-XSRF-TOKEN', token);
    }
    this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
      this.document.location.href = result.data.redirectUrl + "&login_type=anadoluad";
    });
  }

  loginEDevlet() {
    const token = this.tokenExtractor.getToken() as string;
    let headers = new HttpHeaders();
    if (token !== null) {
      headers = headers.append('X-XSRF-TOKEN', token);
    }
    this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
      this.document.location.href = result.data.redirectUrl + "&login_type=edevlet";
    });
  }

  setLang(lang: string) {
    this.currentLang = lang;
    this.translateService.setLang(lang);
  }
}

